import { render } from "./RenderIllustration.vue?vue&type=template&id=a683b20e&scoped=true"
import script from "./RenderIllustration.vue?vue&type=script&lang=js"
export * from "./RenderIllustration.vue?vue&type=script&lang=js"

import "./RenderIllustration.vue?vue&type=style&index=0&id=a683b20e&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a683b20e"]])

export default __exports__